import { InformationListPage } from "@/features/information/pages/InformationList";
import React from "react";

const InformationList = () => {
  return <InformationListPage />;
};

export default InformationList;
